import React from 'react';
import { DownloadIcon, FileTextIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { trustBadges } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
const icons = {
  download: DownloadIcon,
  lock: LockIcon,
  file: FileTextIcon,
  shield: ShieldCheckIcon
};
export function FinalCta() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="w-full bg-ink px-5 py-20 text-white sm:px-8" data-id="element-85" data-mp="1ee1ulz7fhnts">
      <div className="mx-auto w-full max-w-2xl" data-id="element-86" data-mp="1eds6yi9uvsr9">
        <Reveal data-id="element-87" data-mp="1t3g5jbqnkdba">
          <h2 className="text-center font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-88" data-mp="1t1wqfogqg8b3">
            Your next practice can keep being improvised.{' '}
            <span className="text-cheer" data-id="element-89" data-mp="22336jwfgzh3t">
              OR you can finally have a real system.
            </span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-90" data-mp="1x6ct7gv1uzm3">
          <div className="mt-12 rounded-card border border-cheer/50 bg-[#121218] p-6" data-id="element-91" data-mp="n5m887qsge4i">
            <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-92" data-mp="n7yyr9am3wt6">
              <div data-id="element-93" data-mp="s4xpriyzbnn5">
                <p className="font-display text-base font-extrabold uppercase tracking-tight" data-id="element-94" data-mp="s6iid31qgwid">
                  Cheerleading Ready 360 — Complete Pack
                </p>
                <p className="mt-1 text-sm text-white/60" data-id="element-95" data-mp="1246fu0qq4i48">
                  6 Volumes + 5 Bonuses + 360+ pages
                </p>
              </div>
              <span className="rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-navy" data-id="element-96" data-mp="1b31l9aly1o6h">
                Best value
              </span>
            </div>

            <div className="mt-6 flex flex-wrap items-end justify-between gap-6" data-id="element-97" data-mp="1kt3cucdi9oq5">
              <div data-id="element-98" data-mp="1kv7cuj8aa3l5">
                <p className="text-sm text-white/40 line-through" data-id="element-99" data-mp="1psple8ie2gsm">$109</p>
                <p className="font-display text-5xl font-black tracking-tight text-cheer" data-id="element-100" data-mp="1pqmqba2dpxh1">
                  $27
                </p>
              </div>
              <div className="text-right" data-id="element-101" data-mp="3qvqirsxrayku">
                <p className="font-display text-2xl font-extrabold tabular-nums text-white" data-id="element-102" data-mp="3qsb1qkkivfgs">
                  {hours}:{minutes}:{seconds}
                </p>
                <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-white/50" data-id="element-103" data-mp="3iehemtvbu1m">
                  Hrs · Min · Sec
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8" data-id="element-104" data-mp="dehkbuwjnwpm">
            <CtaButton data-id="element-105" data-mp="dhlst4h1lem3" />
          </div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/70 sm:text-sm" data-id="element-106" data-mp="8hh8t4gxe1r4">
            {trustBadges.map(badge => {
            const Icon = icons[badge.icon as keyof typeof icons];
            return <li key={badge.label} className="flex items-center gap-2" data-id="element-107" data-mp="2o7kblbdjedcl">
                  <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-108" data-mp="2o9wtjojaonpn" />
                  {badge.label}
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}